import { useMutation } from "react-query";

import { buildFormDataPayload } from "../../helpers/api";
import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { ReceiptData } from "../../types/ExpenseClaim";

type ExtractReceiptDataPayload = {
  receipt: File;
};

export const extractReceiptData = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (payload: ExtractReceiptDataPayload): Promise<ReceiptData> => {
      return fetchWithAuth<ReceiptData>("extractReceiptData", dossierId, {
        requestOptions: {
          method: "post",
          body: buildFormDataPayload(payload, ["receipt"]),
          excludeContentTypeHeader: true,
        },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
